import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {Specification} from '../entity/specification';
import {SpecificationCharacteristic} from '../entity/specification-characteristic';
import {GoogleService} from './google-service';

@Service()
export class SpecificationService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getSpecifications(id: EntityKey): Observable<Specification[]> {
    let url = this.urlBase + 'specifications/' + id.entityId + '/' + id.entityRevision;
    return this.http.get<Specification[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public saveCharacteristics(id: EntityKey, characteristics: SpecificationCharacteristic[]): Observable<string> {
    let url = this.urlBase + 'specifications/' + id.entityId + '/' + id.entityRevision;
    let body = JSON.stringify(characteristics);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

}
